<template id="map-template">
  <div class="zj-homeview-root select-none">
    <MapView
      MapKey="CockpitMap"
      @layerButtonClick="layerButtonClick"
      @togleSwitchClick="togleSwitchClick"
      @gotLayerData="gotLayerData"
    ></MapView>
    <!-- <div class="left-side" v-show="!isLeftSideHide">
      <div class="left-side-wrapper">
        <div class="left-side-1">
          <div class="content-wrapper">
            <HomeViewWeatherData></HomeViewWeatherData>
          </div>
        </div>
        <div class="left-side-2">
          <div class="content-wrapper">
            <HomeViewPassengerFlow></HomeViewPassengerFlow>
          </div>
        </div>
      </div>
    </div> -->
    <div class="left-bg-box"></div>
    <div class="right-bg-box"></div>
    <div class="right-side2" v-show="!isRightSideHide">
      <div class="right-side-wrapper">
        <div class="right-side-1" v-if="showTaishi">
          <div class="content-wrapper">
            <HomeViewPassengerFlowCockpit></HomeViewPassengerFlowCockpit>
          </div>
        </div>

        <div class="right-side-2" v-if="showTaishi">
          <div class="content-wrapper">
            <HomeViewMessageData></HomeViewMessageData>
          </div>
        </div>
        <div class="right-side-3" v-if="showSheBei">
          <div class="content-wrapper">
            <HomeViewDeviceData></HomeViewDeviceData>
          </div>
        </div>
        <div class="right-side-4" v-if="showSheBei">
          <div class="content-wrapper">
            <HomeViewDeviceAlarm></HomeViewDeviceAlarm>
          </div>
        </div>
        <div class="right-side-3" v-if="showDiaodu">
          <div class="content-wrapper">
            <HomeViewPersonCtrol></HomeViewPersonCtrol>
          </div>
        </div>
      </div>
    </div>
    <div
      class="left-hide-btn"
      :class="{ working: isLeftSideHide }"
      @click="handleLeftHide"
      v-if="showLeft"
    ></div>
    <div
      class="right-hide-btn"
      :class="{ working: isRightSideHide }"
      @click="handleRightHide"
    ></div>
    <div
      class="bottom-hide-btn"
      :class="{ working: isBottomHide }"
      @click="handleBottomHide"
    ></div>
    <el-dialog
      class="map_popup_dialog2"
      v-if="isVideoMonitorDialogVisible"
      top="30vh"
      :visible.sync="isVideoMonitorDialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="实时监控"
    >
      <div class="w100_h100">
        <div class="map_popupbox w100_h15 p10_20_0_0">
          <div class="column">
            <span class="item font1">{{ cameraName }}</span>
            <span class="item">{{
              cameraIsOnline == "1" ? "在线" : "离线"
            }}</span>
          </div>
        </div>
        <div class="videoBig-item w100_h85">
          <flv-player-real-time
            class="videoBig-item"
            :cameraId="cameraId"
            :cameraName="cameraName"
            :cameraIsOnline="cameraIsOnline"
            :item="cameraItem"
            :autoplay="autoplay"
            :streamType="streamType"
            viewMode="noclose"
          />       
        </div>
      </div>
    </el-dialog>
    <!-- 广播弹窗 -->
    <el-dialog
      class="map_popup_dialog_braoadcast"
      v-if="isBroadcastPopVisible"
      top="40vh"
      :visible.sync="isBroadcastPopVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="广播"
    >
      <MapDevicePop ref="infoWindow" :detail="deviceDetail"></MapDevicePop>
    </el-dialog>
    <!-- LED弹窗 -->
    <el-dialog
      class="map_popup_dialog_led"
      v-if="isLEDPopVisible"
      top="40vh"
      :visible.sync="isLEDPopVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="广播"
    >
      <MapDevicePop ref="infoWindow" :detail="ledDetail"></MapDevicePop>
    </el-dialog>
    <!-- WiFi弹窗 -->
    <el-dialog
      class="map_popup_dialog_wifi"
      v-if="isWifiPopVisible"
      top="40vh"
      :visible.sync="isWifiPopVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="WiFi"
    >
      <MapWifiPop ref="infoWindow" :detail="wifiDetail"></MapWifiPop>
    </el-dialog>
    <!-- 停车场弹窗 -->
    <el-dialog
      class="map_popup_dialog_caraprk"
      v-if="isCarparkPopVisible"
      top="40vh"
      :visible.sync="isCarparkPopVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="停车场"
    >
      <MapCarparkPop ref="infoWindow" :detail="carparkDetail"></MapCarparkPop>
    </el-dialog>
    <!-- 出入口弹窗 -->
    <el-dialog
      class="map_popup_dialog_default"
      v-if="isEntranceVisible"
      top="40vh"
      :visible.sync="isEntranceVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="出入口"
    >
      <MapDevicePop ref="infoWindow" :detail="deviceDetail"></MapDevicePop>
    </el-dialog>
    <el-dialog
      class="map_popup_dialog2"
      v-if="isSoSMonitorDialogVisible"
      top="30vh"
      :visible.sync="isSoSMonitorDialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="实时监控"
    >
      <div class="w100_h100">
        <div class="map_popupbox w100_h15 p10_20_0_0">
          <div class="column">
            <span class="item font1">{{ cameraName }}</span>
            <span class="item">{{
              cameraIsOnline == "1" ? "在线" : "离线"
            }}</span>
          </div>
        </div>
        <div class="videoBig-item w100_h85">
          <!-- <flv-player-real-time
            class="videoBig-item"
            :cameraId="cameraId"
            :cameraName="cameraName"
            :cameraIsOnline="cameraIsOnline"
            :autoplay="autoplay"
            :streamType="streamType"
            viewMode="noclose"
          /> -->
          <ZjHikCameraVideo
            :sysParams="sysParams"
            :cameraIndexCode="cameraId"
            :isShow="isVideoMonitorDialogVisible"
          ></ZjHikCameraVideo>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="map_popup_dialog"
      destroy-on-close="true"
      top="30vh"
      :visible.sync="isBroadcastDialogVisible"
      title="人工广播"
    >
      <home-view-broadcast-panel
        class="videoBig-item"
        :deviceId="broadcastDeviceId"
      />
    </el-dialog>
  </div>
</template>

<script>
import MapView from "./components/HomeMapView";
// import HomeViewWeatherData from "./components/HomeViewWeatherData";
import HomeViewPassengerFlowCockpit from "./components/HomeViewPassengerFlowCockpit";
import HomeViewMessageData from "./components/HomeViewMessageData";

import HomeViewDeviceData from "./components/HomeViewDeviceData";

import HomeViewDeviceAlarm from "./components/HomeViewDeviceAlarm";
import HomeViewPersonCtrol from "./components/HomeViewPersonCtrol";
import HomeViewBroadcastPanel from "./components/HomeViewBroadcastPanel";
import MapDevicePop from "./components/MapDevicePop";
import MapWifiPop from "./components/MapWifiPop";
import MapCarparkPop from "./components/MapCarparkPop";
import ZjHikCameraVideo from "@/components/src/HikCameraVideo";
import { listEquipmentArea } from "@/api/src/equipmentArea";

export default {
  name: "HomeView",
  componentName: "HomeView",
  components: {
    MapView,
    // HomeViewWeatherData,
    HomeViewPassengerFlowCockpit,

    HomeViewMessageData,
    HomeViewDeviceData,
    //  HomeViewTaskCenter,

    HomeViewDeviceAlarm,
    HomeViewBroadcastPanel,
    HomeViewPersonCtrol,
    MapDevicePop,
    MapWifiPop,
    MapCarparkPop,
    ZjHikCameraVideo
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      isLeftSideHide: false,
      isRightSideHide: false,
      isBottomHide: false,
      isVideoMonitorDialogVisible: false,
      isSoSMonitorDialogVisible: false,
      isBroadcastDialogVisible: false,
      isBroadcastPopVisible: false,
      isWifiPopVisible: false,
      isCarparkPopVisible: false,
      isLEDPopVisible: false,
      isEntranceVisible: false,
      streamType: 1, //0 - 主码流；1 - 子码流
      autoplay: true,
      cameraId: "",
      cameraName: "",
      cameraIsOnline: true,
      cameraItem:{},
      broadcastDeviceId: "",
      broadcastName: "",
      isShow: true,
      showTaishi: true,
      showDiaodu: false,
      showSheBei: false,
      deviceDetail: {
        deviceName: "",
        deviceIsOnline: "",
        deviceIP: "",
        deviceRegionName: "",
      },
      ledDetail: {
        deviceName: "",
        deviceIsOnline: "",
        deviceIP: "",
        deviceRegionName: "",
      },
      wifiDetail: {
        deviceName: "",
        deviceIsOnline: "",
        deviceIP: "",
        deviceRegionName: "",
        count: null,
      },
      carparkDetail: {
        name: "",
        totalPlace: 0,
        usedSpace: 0,
        percent: 0,
      },
      showLeft: false,
      regionList: null,
      sysParams: {
        appkey: "",
        secret: "",
        ip: "",
        port: 443,
        videoWidth: 700,
        videoHeight: 500,
        screenWidth: 710,
        screenHeight: 510,
        cameraIndexCode: "",
      }
    };
  },
  methods: {
    handleLeftHide: function () {
      this.isLeftSideHide = !this.isLeftSideHide;
      if (this.isLeftSideHide) {
        // eslint-disable-next-line no-undef
        $("#CockpitMapTabs").hide();
      } else {
        // eslint-disable-next-line no-undef
        $("#CockpitMapTabs").show();
      }
    },
    handleRightHide: function () {
      this.isRightSideHide = !this.isRightSideHide;
    },
    handleBottomHide: function () {
      this.isBottomHide = !this.isBottomHide;

      if (this.isBottomHide) {
        // eslint-disable-next-line no-undef
        $(".toggles.horizontal_cocketmap_tree_toggles").hide();
      } else {
        // eslint-disable-next-line no-undef
        $(".toggles.horizontal_cocketmap_tree_toggles").show();
      }
    },
    dialogclose() {
      console.log(this.isShow);
      this.isShow = false;
    },
    dialogopen() {
      console.log(this.isShow);
      this.isShow = true;
    },
    togleSwitchClick(e) {
      // this.broadcast(
      //   "HomeViewPassengerFlowCockpit",
      //   "onMapToogleGroupSwitchClick",
      //   e.type
      // );
      let type = e.type;

      switch (type) {
        case "景区态势":
          this.showTaishi = true;
          this.showDiaodu = false;
          this.showSheBei = false;

          break;
        case "指挥调度":
          this.showDiaodu = true;
          this.showTaishi = false;
          this.showSheBei = false;

          break;
        case "景区设备":
          this.showSheBei = true;
          this.showDiaodu = false;
          this.showTaishi = false;

          break;
        default:
          this.showTaishi = true;
          this.showDiaodu = false;
          this.showSheBei = false;

          break;
      }
    },
    layerButtonClick: function (data) {
      let e = data.e;
      switch (data.action) {
        case "videomonitor":
          this.cameraId = e.data.equipmentCode;
          this.cameraName = e.data.equipmentName;
          this.cameraIsOnline = e.data.onlineStatus;
          this.cameraItem = e.data;
          this.isVideoMonitorDialogVisible = true;
          break;
        // case "broadcastPop":
        //   this.deviceDetail.deviceName = e.data.DeviceName;
        //   this.deviceDetail.deviceIsOnline = e.data.IsOnline ? "在线" : "离线";
        //   this.deviceDetail.deviceIP = JSON.parse(e.data.JsonExtend).IP;
        //   this.deviceDetail.deviceRegionName = e.data.RegionName;
        //   this.isBroadcastPopVisible = true;
        //   break;
        // case "SOSPop":
        //   this.cameraId = e.data.id;
        //   this.cameraName = e.data.equipmentName;
        //   this.cameraIsOnline = e.data.onlineStatus;
        //   //  this.isVideoMonitorDialogVisible = true;
        //   this.isSoSMonitorDialogVisible = true;
        //   break;
        case "broadcastPop":
          this.deviceDetail.deviceName = e.data.equipmentName;
          this.deviceDetail.deviceIsOnline = e.data.onlineStatus ? "在线" : "离线";
          this.deviceDetail.deviceIP = e.data.equipmentIp;
          this.deviceDetail.deviceRegionName = e.data.areaCodeTranslated;
          this.isBroadcastPopVisible = true;
          break;
          case "SOSPop":
            console.log(e.data,'sosPop----')
            // this.cameraId = e.data.channelNo;
            // this.cameraIsOnline = e.data.onlineStatus;
            // this.cameraName = e.data.equipmentName;
            // this.sysParams = {
            //   appkey: e.data.userName,
            //   secret: e.data.userPw,
            //   ip: e.data.equipmentIp,
            //   port: e.data.equipmentPort,
            //   videoWidth: 600,
            //   videoHeight: 400,
            //   screenWidth: 610,
            //   screenHeight: 410,
            //   cameraIndexCode: e.data.channelNo,
            // }
            // this.isSoSMonitorDialogVisible = true;
            this.cameraId = e.data.equipmentCode;
            this.cameraName = e.data.equipmentName;
            this.cameraIsOnline = e.data.onlineStatus;
            this.isVideoMonitorDialogVisible = true;
          break;
        case "WiFiPop":
          // this.regionList.forEach((item) => {
          //   if (e.data.Extend1 == item.areaCode) e.data.Extend1 = item.areaName;
          // });
          this.wifiDetail.deviceName = e.data.equipmentName;
          this.wifiDetail.deviceIsOnline = e.data.onlineStatusTranslated;
          this.wifiDetail.deviceIP = e.data.equipmentIp;
          this.wifiDetail.deviceRegionName = e.data.areaCodeTranslated;
          this.wifiDetail.count = e.data.wifiUsr;
          this.isWifiPopVisible = true;
          break;
        case "CarparkPop":
          this.carparkDetail.name = e.data.name;
          this.carparkDetail.totalPlace = e.data.totalNum;
          this.carparkDetail.usedSpace = e.data.useNum;

          this.carparkDetail.percent =
            (e.data.useNum / e.data.totalNum).toFixed(2) * 100 || 0;
          this.isCarparkPopVisible = true;
          break;
        case "LEDPop":
          this.ledDetail.deviceName = e.data.NAME_EQT;
          this.ledDetail.deviceIsOnline =
            e.data.STATE_EQT === 1 ? "在线" : "离线";
          this.ledDetail.deviceIP = e.data.IPAdd_EQT;
          this.ledDetail.deviceRegionName = e.data.ARENUM_EQT;
          this.isLEDPopVisible = true;
          break;
        case "entrancePop":
          this.deviceDetail.deviceName = e.data.name;

          this.isEntranceVisible = true;
          break;

        case "broadcastControl":
          this.broadcastDeviceId = e.data.DeviceId;
          this.broadcastName = e.data.DeviceName;
          this.isBroadcastDialogVisible = true;
          break;
        default:
          this.$message({ type: "warning", message: data.action + "未实现" });
          break;
      }
    },
    gotLayerData(data) {
      if ($(".CockpitMap-tab-left").length > 0) {
        this.showLeft = true;
      } else {
        this.showLeft = false;
      }
    },
    getRegionList() {
      listEquipmentArea().then((response) => {
        this.regionList = response.rows;
      });
    },
  },
  created() {},
  mounted() {
    this.getRegionList();
  },
  beforeDestroy() {},
  destroyed() {
    // 销毁组件时，还原样式
    // eslint-disable-next-line no-undef
    this.theme.header.visiable = true;
    this.theme.sidemenu.visiable = true;
  },
  controller: "UI",
  action: "HomeView",
};
</script>
<style scoped>
.left-bg-box {
  position: absolute;
  width: 28.8333rem;
  height: 100%;
  top: 0px;
  left: 0px;
  /* background-image: url("../../theme-default/src/images/bg_left.png"); */
  background-image: url("../../theme-default/src/images/bg_right.png");
  transform: rotateY(180deg);
}
.right-bg-box {
  position: absolute;
  width: 27.9167rem;
  height: 100%;
  top: 0px;
  right: 0px;
  background-image: url("../../theme-default/src/images/bg_right.png");
}
</style>